<template>
  <div class="nl-split">
    <div class="nl-split__card">
      <div
        class="nl-split__hero"
        :style="{ backgroundImage: `url('${heroImage}')` }"
        :role="heroAlt ? 'img' : null"
        :aria-label="heroAlt || null"
        :aria-hidden="heroAlt ? null : 'true'"
      />
      <div class="nl-split__panel">
        <div v-if="!hideLogo" class="nl-split__logo">
          <b-img :src="logoSrc" :width="logoWidth" :alt="logoAlt" />
        </div>
        <main class="nl-split__content">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginSplitLayout',
  props: {
    heroImage: {
      type: String,
      required: true
    },
    heroAlt: {
      type: String,
      default: ''
    },
    logoSrc: {
      type: String,
      required: true
    },
    logoAlt: {
      type: String,
      default: 'logo'
    },
    logoWidth: {
      type: [String, Number],
      default: 184
    },
    hideLogo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.nl-split {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacer*3 $spacer;

  // On tall/portrait viewports (e.g. tablets in portrait) dead-centering the
  // card leaves a big empty gap at the top. Pin it near the top instead and
  // let the slack fall below, above the footer.
  @media (orientation: portrait) and (min-width: 768px) {
    align-items: flex-start;
    padding-top: $spacer*5;
  }

  &__card {
    display: flex;
    width: 100%;
    max-width: 1100px;
    min-height: 600px;
    background-color: $nl-surface;
    border-radius: $nl-card-radius;
    box-shadow: $nl-card-shadow;
    overflow: hidden;
  }

  &__hero {
    flex: 0 0 41%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  &__panel {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: $spacer*3 $spacer*4;
  }

  &__logo {
    display: flex;
    justify-content: center;
  }

  &__content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 369px;
    margin: 0 auto;
    padding: $spacer*3 0;
  }
}

// Mobile: full-bleed per Figma — drop the hero and the floating-card chrome
// (shadow / radius / max-width). Content sits directly on the white page,
// pinned to the top, with 16px side gutters.
@include media-breakpoint-down(sm) {
  .nl-split {
    align-items: flex-start;
    padding: 0;

    &__card {
      max-width: none;
      min-height: 0;
      background-color: transparent;
      border-radius: 0;
      box-shadow: none;
      overflow: visible;
    }

    &__hero {
      display: none;
    }

    &__panel {
      padding: $spacer*3 $spacer $spacer*2;
    }

    &__logo {
      justify-content: center;
    }

    &__content {
      flex: 0 0 auto;
      justify-content: flex-start;
      max-width: none;
      padding: $spacer*3 0 0;
    }
  }
}
</style>
